exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-svg-loader {\n  display: block;\n}\n.md-svg-loader svg {\n  width: 100%;\n}", ""]);

// exports
